var map = {
	"./translations/de.json": "8246",
	"./translations/de_CH.json": "f1b4",
	"./translations/en.json": "f4dd",
	"./translations/en_AU.json": "116d",
	"./translations/en_GB.json": "7b69",
	"./translations/en_US.json": "54a8",
	"./translations/es.json": "3f7e",
	"./translations/fr.json": "5cd6",
	"./translations/fr_BE.json": "598c",
	"./translations/it.json": "fac3",
	"./translations/nl.json": "2de4",
	"./translations/nl_BE.json": "9d83",
	"./translations/pr.json": "1806",
	"./translations/pt.json": "83a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "885f";